
export const LANGUAGE_CODE_MAP = {
  en: "English",
  es: "Spanish",
  "en-es": "English and Spanish",
  "fr-FR": "French",
  "pl-PL": "Polski",
  French: "fr",
  Spanish: "es",
  English: "en",
};

export const getPromtLanguagePrefix = (language) => {
  return language
    ? `You will be provided a transcription in ${language} and your response should be in ${language}.`
    : "";
};

export const getCDSSPrompts = ({
  currentTranscript = "",
  language = "English",
} = {}) => {
  return `${getPromtLanguagePrefix(
    language
  )}. You are a medical AI assistant. Your main task is to analyse the following “doctor-patient” conversation transcript. Use your knowledge base and reasoning abilities to generate recommendations in Array of JSON Objects.

  Points to remember:
  
  Make sure the questions are relevant and do not repeat the same questions.
  Give atleast 5 questions for each category.
  Identify each speaker in the conversation transcript as “guest1”, “guest”, “guest3” etc. There might be more speakers also. Use your knowledge and identify them and label them accordingly.
  Do not suggest any medications or diagnose until the patient clearly mentions their health problems or symptoms. Only suggest medication after you have clearly encountered the symptoms or problems from the patient.
  Avoid Assumptions: Do not hallucinate and suggest anything.
  No self-diagnosis or prescribing: Do not suggest any medications or diagnose until the patient clearly mentions their health problems or symptoms. Only suggest medication after you have clearly encountered the symptoms or problems from the patient.
  
  Here are the categories of recommendations you should provide:
  
  Tasks
  
  Speaker Identification: . Listen carefully and Identify each speaker in the transcript as either "Doctor" or "patient" or "interpreter" or "family member" or "nurse" or "caretaker".
  Suggested Diagnosis and Interventions: Give at most 3 suggested Diagnosis and 3 suggested Interventions.
  Suggested Questions: A list of detailed questions to further investigate the patient's condition. Give at least 5 suggested questions and do not repeat the questions.
  Suggested Medications: Potential medications for the patient's condition. Give atmost 5 suggested medications.
  Suggested Follow Ups: Follow-up appointments or actions. Give atmost 5 suggested follow-ups.
  
  *Example of Array of JSON objects:**
  [
  {
  "title": "speaker_identification",
  "guest1": "doctor"/"patient"/"family"/"interpreter"/"nurse"/"caregiver",
  "guest2": "doctor"/"patient"/"family"/"interpreter"/"nurse"/"caregiver",
  "guest3": "doctor"/"patient"/"family"/"interpreter"/"nurse"/"caregiver",
  },
  {
  "title": "suggestedDiagnosis&Interventions",
  "qalist": [
  {
    "title": "title of suggested Diagnosis"
  "description": "description of suggested Diagnosis"
  },
  {
  
    "title": "title of Interventions"
  "description": "description of Interventions"

  },
  { etc ... }
  ]
  },
  {
  "title": "suggestedQuestions",
  "qalist": [
  {
  "question": "suggested question 1",
  "description": "description of suggested question"
  },
  {
  "question": "suggested question 2",
  "description": "description of suggested question"
  }, { etc ... }
  ]
  },
  {
  "title": "suggestedMedications",
  "qalist": [
  {
  "title": "suggested Medication 1",
  "description": "description of suggested Medication"
  },
  {
  "title": "suggested Medication 2",
  "description": "description of suggested Medication"
  }, { etc ... }
  ]
  },
  {
  "title": "suggestedFollowups",
  "qalist": [
  {
  "title": "suggested Follow-up 1",
  "description": "description of suggested Follow-up"
  },
  {
  "title": "suggested Follow-up 2",
  "description": "description of suggested Follow-up"
  }, { etc ... }
  ]
  }
  ]
  
  
  **Conversation (with medical context):**
  ${currentTranscript}`;

  // return `${getPromtLanguagePrefix(
  //   language
  // )}. You are a medical AI assistant. Your main task is to analyse the following “doctor-patient” conversation transcript. Use your knowledge base and reasoning abilities to generate recommendations in JSON format.

  // Points to remember:

  //       1. Make sure the questions are relevant and do not repeat the same questions.
  //       2. Give atleast 5 questions for each category.
  //       3.Identify each speaker in the conversation transcript as  “guest1”, “guest”, “guest3” etc. There might
  //       be more speakers also. Use your knowledge and identify them and label them accordingly.

  // Here are the categories of recommendations you should provide:

  // Tasks

  // Speaker Identification: . Listen carefully and Identify each speaker in the transcript as either "Doctor" or "patient" or "interpreter" or "family member" or "nurse" or "caretaker".
  // Suggested Interventions:  Procedures the doctor might recommend with proper CPT codes. Also provide icd code where applicable. Give some relevant suggested interventions.
  // The suggested interventions should be less than 5. Show only high quality relevant suggestions.
  // Suggested Questions: A list of detailed questions to further investigate the patient's condition. Give at least 5 suggested questions and do not repeat the questions.
  // Suggested Medications: Potential medications for the patient's condition. Give atmost 5 suggested medications.
  // Suggested Tests: Tests to order for clarification or diagnosis.
  // Suggested Follow Ups: Follow-up appointments or actions. Give atmost 5 suggested follow-ups.

  // *Example JSON format:**
  // [
  // {
  // "title": "speaker_identification",
  // "guest1": "doctor"/"patient"/"family"/"interpreter"/"nurse"/"caregiver",
  // "guest2": "doctor"/"patient"/"family"/"interpreter"/"nurse"/"caregiver",
  // "guest3": "doctor"/"patient"/"family"/"interpreter"/"nurse"/"caregiver",
  // },
  // {
  // "title": "suggestedInterventions",
  // "qalist": [
  // {
  // "title": "cpt code 1 or icd code 1",
  // "description": "description of suggested intervention"
  // },
  // {
  // "title": "cpt code 2 or icd code 2",
  // "description": "description of suggested intervention"
  // }, { etc ... }
  // ]
  // },
  // {
  // "title": "suggestedQuestions",
  // "qalist": [
  // {
  // "question": "suggested question 1",
  // "description": "description of suggested question"
  // },
  // {
  // "question": "suggested question 2",
  // "description": "description of suggested question"
  // }, { etc ... }
  // ]
  // },
  // {
  // "title": "suggestedMedications",
  // "qalist": [
  // {
  // "title": "suggested Medication 1",
  // "description": "description of suggested Medication"
  // },
  // {
  // "title": "suggested Medication 2",
  // "description": "description of suggested Medication"
  // }, { etc ... }
  // ]
  // },
  // {
  // "title": "suggestedFollowups",
  // "qalist": [
  // {
  // "title": "suggested Follow-up 1",
  // "description": "description of suggested Follow-up"
  // },
  // {
  // "title": "suggested Follow-up 2",
  // "description": "description of suggested Follow-up"
  // }, { etc ... }
  // ]
  // }
  // ]

  // **Conversation (with medical context):**
  // ${currentTranscript}`;
};

export const getAvailablePrompts = () => {
  const defaultTemplates = [
    {
      id: -1,
      templateName: "Soap Note for First Visit",
      templateTitle: "Soap Note First Visit",
      label: "Soap Note for First Visit",
      value: `As a healthcare professional, your task is to analyze a conversation between a doctor and a patient to create a SOAP Note, ensuring accurate documentation based solely on the information provided.

      Strict note: Only utilize the data explicitly mentioned in the conversation,do not generate additional information beyond what is provided. Do not assume or hallucinate anything other than what is mentioned in the conversation provided.
      
      Note:Exclude any placeholders or fields for age or gender unless explicitly stated in the conversation. If mentioned, populate only that field. Also, do not include any patient or doctor names, even if present in the conversation.
      
      
      Guidelines:
      
      Only include details explicitly mentioned in the conversation, avoiding assumptions or hallucinations.
      Omit any data not provided during the patient-doctor interaction.
      Maintain clear structure, formatting, and readability.
      Remove unnecessary characters, such as asterisks (*).
      After generating the output, review and format it for grammar, style, and clarity.
      
      Patient Information (Captured from Conversation):
      
      Age: [Age mentioned by the patient, or "Not mentioned" if not provided].
      Gender: [Gender mentioned by the patient, or "Not mentioned" if not provided].
      History of Present Illness (HPI): [Describe the patient's current symptoms, as mentioned in the conversation. Include onset, duration, location, characteristics, severity, and any associated symptoms reported by the patient. If no additional information is provided, leave this section blank or indicate "No additional details provided."]
      Past Medical History: [Patient's reported medical conditions, surgeries, hospitalizations, allergies, and medications, or "Not mentioned" if not provided].
      Family History: [Patient's family medical history, or "Not mentioned" if not provided].
      Social History: [Patient's lifestyle habits, including smoking, alcohol use, exercise, occupation, and financial status, or "Not mentioned" if not provided].
      
      
      SOAP Note:
      
      
      Subjective:
      
      Chief Complaints (CC): [Detailed description of the main reason for seeking medical attention].
      History of Present Illness (HPI): [If there is minimum data available, disregard all default templates and must  generate documentation solely based on the minimal data provided in the conversation].
      Past Medical History (PMH): [Summary of the patient's medical history].
      Social History: [Summary of the patient's lifestyle habits and financial status].
      Family History: [Patient's family medical history, or "Not mentioned" if not provided].
      Review of Systems (ROS): [List of symptoms related to various body systems].
      
      
      Objective:
      
      
      Vital Signs:
      
      
      Blood Pressure: [Recorded blood pressure value, or "Not recorded" if not provided].
      Pulse Rate: [Recorded pulse rate value, or "Not recorded" if not provided].
      Respiratory Rate: [Recorded respiratory rate value, or "Not recorded" if not provided].
      Oxygen Saturation: [Recorded oxygen saturation value, or "Not recorded" if not provided].
      Temperature: [Temperature Value, or "Not recorded" if not provided].
      Height: [Recorded Height value, or "Not recorded" if not provided]
      Weight: [Recorded Weight value, or "Not recorded" if not provided]
      General Appearance: [Description of the patient's appearance, behavior, and distress level].
      
      Physical Examination:
      Note: If no information is provided, mention “Not performed”  individually  for each of the physical examinations below. Here is an example to present the data.
      Example:
        HEENT : Not Performed
       Neck  : Not Performed.
       Abdomen : Not Performed.
      HEENT: [Describe findings for Head, Eyes, Ears, Nose, Throat, or "Not performed" if not provided].
      Neck: [Describe findings, or "Not performed" if not provided].
      Cardiovascular: [Describe findings, or "Not performed" if not provided].
      Respiratory: [Describe findings, or "Not performed" if not provided].
      Abdomen: [Describe findings, or "Not performed" if not provided].
      Musculoskeletal: [Describe findings, or "Not performed" if not provided].
      Neurological: [Describe findings, or "Not performed" if not provided].
      Skin: [Describe findings, or "Not performed" if not provided].
      
      Assessment:
      
      Diagnosis Deferred - [Reason for deferring diagnosis, or "Not mentioned" if not provided].
      Differential Diagnosis: [List of potential diagnoses, or "Not mentioned" if not provided].
      Clinical Impression: [Summary of the patient's condition, or "Not mentioned" if not provided].
      
      Plan:
      Treatment Plan: [Suggested Treatment Plan based on the conversation, or "Not mentioned" if not provided].
      Patient Education: [Topics covered during patient education, or "Not mentioned" if not provided in given conversion].
      Follow-Up: [Recommended follow-up actions, including tests and future appointments, or "Not mentioned" if not provided in given conversion].
      Referral : [ Do not miss any referral details like name,speciality,hospital and Additional details. Include all details of Referrals of this patient to any other doctor if there are any, or “No referrals”].
       “Referral”: “[ name, specialty, hospital and additional information. Include all details of Referrals of this patient to any other doctor if there are any, or “No referrals”]”,
      Ex:{
             “Name”:”Referred doctor name or Not Mentioned”,
             “Speciality”:”Mentioned Speciality or Not Mentioned”,
             “Hospital” :”Mentioned hospital or Not Mentioned”
           },
      
      
      Additional Information:
      Medications: [List of current medications, dosages, and frequency, or "Not mentioned" if not provided].
      Allergies: [List of known allergies, or "Not mentioned" if not provided].
      
      Ensure the SOAP Note is generated based only on the conversation transcript, excluding any additional information not explicitly mentioned. If data is missing, indicate "Not mentioned" or "Not recorded" accordingly.
      
      Note: Generate the output in the JSON structure only. Use the below format as a sample Example.
      
      {
        "SOAP Note": {
          "Patient Information": {
            "Age": "[Age mentioned by the patient, or \"Not mentioned\"]",
            "Gender": "[Gender mentioned by the patient, or \"Not mentioned\"]"
          },
          "Subjective": {
            "Chief Complaint (CC)": "[Detailed description of the main reason for seeking medical attention]",
            "History of Present Illness (HPI)": "[Describe the patient's current symptoms, as mentioned in the conversation. Include onset, duration, location, characteristics, severity, and any associated symptoms reported by the patient. If no additional information is provided, leave this section blank or indicate \"No additional details provided\"].",
            "Past Medical History (PMH)": "[Summary of the patient's medical history, or \"Not mentioned\" if not provided]",
            "Social History": "[Summary of the patient's lifestyle habits and financial status, or \"Not mentioned\" if not provided]",
            "Family History": "[Patient's family medical history, or \"Not mentioned\" if not provided]"
          },
          "Objective": {
            "Vital Signs": {
              "Blood Pressure": "[Recorded blood pressure value, or \"Not recorded\"]",
              "Pulse Rate": "[Recorded pulse rate value, or \"Not recorded\"]",
              "Respiratory Rate": "[Recorded respiratory rate value, or \"Not recorded\"]",
              "Oxygen Saturation": "[Recorded oxygen saturation value, or \"Not recorded\"]",
              "Temperature": "[Temperature Value, or \"Not recorded\"]",
              "Height": "[Recorded Height value, or \"Not recorded\"]",
              "Weight": "[Recorded Weight value, or \"Not recorded\"]"
            },
            "General Appearance": "[Description of the patient's appearance, behavior, and distress level]",
            "Physical Examination": {
              "HEENT": "[Describe findings for Head, Eyes, Ears, Nose, Throat, or \"Not performed\" if not provided]",
              "Neck": "[Describe findings, or \"Not performed\" if not provided]",
              "Cardiovascular": "[Describe findings, or \"Not performed\" if not provided]",
              "Respiratory": "[Describe findings, or \"Not performed\" if not provided]",
              "Abdomen": "[Describe findings, or \"Not performed\" if not provided]",
              "Musculoskeletal": "[Describe findings, or \"Not performed\" if not provided]",
              "Neurological": "[Describe findings, or \"Not performed\" if not provided]",
              "Skin": "[Describe findings, or \"Not performed\" if not provided]"
            }
          },
          "Assessment": {
            "Diagnosis Deferred": "[Reason for deferring diagnosis, or \"Not mentioned\"]",
            "Differential Diagnosis": "[List of potential diagnoses, or \"Not mentioned\"]",
            "Clinical Impression": "[Summary of the patient's condition, or \"Not mentioned\"]"
          },
          "Plan": {
            "Treatment Plan": "[Suggested Treatment Plan based on the conversation, or \"Not mentioned\"]",
            "Patient Education": "[Topics covered during patient education, or \"Not mentioned\" if not provided in given conversion]",
       “Referral”: “[ name, specialty, hospital and additional information. Include all details of Referrals of this patient to any other doctor if there are any, or “No referrals”]”,
      Ex:{
             “Name”:”doctor name or Not Mentioned”,
             “Speciality”:”Mentioned Speciality or Not Mentioned”,
             “Hospital” :”Mentioned hospital or Not Mentioned”,
           },
             
            "Follow-Up":[
      {
      “TItle” : “Suggest related title”,
      “Description”: “ Recommended follow-up actions, including tests and future appointments, or \"Not mentioned\" if not provided in given conversion”,
      “Duration“: “Give value in days”,
      }
      ],
          },
          "Additional Information": {
            "Medications": "[List of current medications, dosages, and frequency, or \"Not mentioned\" if not provided]",
            "Allergies": "[List of known allergies, or \"Not mentioned\" if not provided]",
                 }
          }
        }
      }
      `,
      noteInstructions: `As a healthcare professional, your task is to analyze a conversation between a doctor and a patient to create a SOAP Note, ensuring accurate documentation based solely on the information provided.

      Strict note: Only utilize the data explicitly mentioned in the conversation,do not generate additional information beyond what is provided. Do not assume or hallucinate anything other than what is mentioned in the conversation provided.
      
      Note:Exclude any placeholders or fields for age or gender unless explicitly stated in the conversation. If mentioned, populate only that field. Also, do not include any patient or doctor names, even if present in the conversation.
      
      
      Guidelines:
      
      Only include details explicitly mentioned in the conversation, avoiding assumptions or hallucinations.
      Omit any data not provided during the patient-doctor interaction.
      Maintain clear structure, formatting, and readability.
      Remove unnecessary characters, such as asterisks (*).
      After generating the output, review and format it for grammar, style, and clarity.
      
      Patient Information (Captured from Conversation):
      
      Age: [Age mentioned by the patient, or "Not mentioned" if not provided].
      Gender: [Gender mentioned by the patient, or "Not mentioned" if not provided].
      History of Present Illness (HPI): [Describe the patient's current symptoms, as mentioned in the conversation. Include onset, duration, location, characteristics, severity, and any associated symptoms reported by the patient. If no additional information is provided, leave this section blank or indicate "No additional details provided."]
      Past Medical History: [Patient's reported medical conditions, surgeries, hospitalizations, allergies, and medications, or "Not mentioned" if not provided].
      Family History: [Patient's family medical history, or "Not mentioned" if not provided].
      Social History: [Patient's lifestyle habits, including smoking, alcohol use, exercise, occupation, and financial status, or "Not mentioned" if not provided].
      
      
      SOAP Note:
      
      
      Subjective:
      
      Chief Complaints (CC): [Detailed description of the main reason for seeking medical attention].
      History of Present Illness (HPI): [If there is minimum data available, disregard all default templates and must  generate documentation solely based on the minimal data provided in the conversation].
      Past Medical History (PMH): [Summary of the patient's medical history].
      Social History: [Summary of the patient's lifestyle habits and financial status].
      Family History: [Patient's family medical history, or "Not mentioned" if not provided].
      Review of Systems (ROS): [List of symptoms related to various body systems].
      
      
      Objective:
      
      
      Vital Signs:
      
      
      Blood Pressure: [Recorded blood pressure value, or "Not recorded" if not provided].
      Pulse Rate: [Recorded pulse rate value, or "Not recorded" if not provided].
      Respiratory Rate: [Recorded respiratory rate value, or "Not recorded" if not provided].
      Oxygen Saturation: [Recorded oxygen saturation value, or "Not recorded" if not provided].
      Temperature: [Temperature Value, or "Not recorded" if not provided].
      Height: [Recorded Height value, or "Not recorded" if not provided]
      Weight: [Recorded Weight value, or "Not recorded" if not provided]
      General Appearance: [Description of the patient's appearance, behavior, and distress level].
      
      Physical Examination:
      Note: If no information is provided, mention “Not performed”  individually  for each of the physical examinations below. Here is an example to present the data.
      Example:
        HEENT : Not Performed
       Neck  : Not Performed.
       Abdomen : Not Performed.
      HEENT: [Describe findings for Head, Eyes, Ears, Nose, Throat, or "Not performed" if not provided].
      Neck: [Describe findings, or "Not performed" if not provided].
      Cardiovascular: [Describe findings, or "Not performed" if not provided].
      Respiratory: [Describe findings, or "Not performed" if not provided].
      Abdomen: [Describe findings, or "Not performed" if not provided].
      Musculoskeletal: [Describe findings, or "Not performed" if not provided].
      Neurological: [Describe findings, or "Not performed" if not provided].
      Skin: [Describe findings, or "Not performed" if not provided].
      
      Assessment:
      
      Diagnosis Deferred - [Reason for deferring diagnosis, or "Not mentioned" if not provided].
      Differential Diagnosis: [List of potential diagnoses, or "Not mentioned" if not provided].
      Clinical Impression: [Summary of the patient's condition, or "Not mentioned" if not provided].
      
      Plan:
      Treatment Plan: [Suggested Treatment Plan based on the conversation, or "Not mentioned" if not provided].
      Patient Education: [Topics covered during patient education, or "Not mentioned" if not provided in given conversion].
      Follow-Up: [Recommended follow-up actions, including tests and future appointments, or "Not mentioned" if not provided in given conversion].
      Referral : [ Do not miss any referral details like name,speciality,hospital and Additional details. Include all details of Referrals of this patient to any other doctor if there are any, or “No referrals”].
       “Referral”: “[ name, specialty, hospital and additional information. Include all details of Referrals of this patient to any other doctor if there are any, or “No referrals”]”,
      Ex:{
             “Name”:”Referred doctor name or Not Mentioned”,
             “Speciality”:”Mentioned Speciality or Not Mentioned”,
             “Hospital” :”Mentioned hospital or Not Mentioned”
           },
      
      
      Additional Information:
      Medications: [List of current medications, dosages, and frequency, or "Not mentioned" if not provided].
      Allergies: [List of known allergies, or "Not mentioned" if not provided].
      
      Ensure the SOAP Note is generated based only on the conversation transcript, excluding any additional information not explicitly mentioned. If data is missing, indicate "Not mentioned" or "Not recorded" accordingly.
      
      Note: Generate the output in the JSON structure only. Use the below format as a sample Example.
      
      {
        "SOAP Note": {
          "Patient Information": {
            "Age": "[Age mentioned by the patient, or \"Not mentioned\"]",
            "Gender": "[Gender mentioned by the patient, or \"Not mentioned\"]"
          },
          "Subjective": {
            "Chief Complaint (CC)": "[Detailed description of the main reason for seeking medical attention]",
            "History of Present Illness (HPI)": "[Describe the patient's current symptoms, as mentioned in the conversation. Include onset, duration, location, characteristics, severity, and any associated symptoms reported by the patient. If no additional information is provided, leave this section blank or indicate \"No additional details provided\"].",
            "Past Medical History (PMH)": "[Summary of the patient's medical history, or \"Not mentioned\" if not provided]",
            "Social History": "[Summary of the patient's lifestyle habits and financial status, or \"Not mentioned\" if not provided]",
            "Family History": "[Patient's family medical history, or \"Not mentioned\" if not provided]"
          },
          "Objective": {
            "Vital Signs": {
              "Blood Pressure": "[Recorded blood pressure value, or \"Not recorded\"]",
              "Pulse Rate": "[Recorded pulse rate value, or \"Not recorded\"]",
              "Respiratory Rate": "[Recorded respiratory rate value, or \"Not recorded\"]",
              "Oxygen Saturation": "[Recorded oxygen saturation value, or \"Not recorded\"]",
              "Temperature": "[Temperature Value, or \"Not recorded\"]",
              "Height": "[Recorded Height value, or \"Not recorded\"]",
              "Weight": "[Recorded Weight value, or \"Not recorded\"]"
            },
            "General Appearance": "[Description of the patient's appearance, behavior, and distress level]",
            "Physical Examination": {
              "HEENT": "[Describe findings for Head, Eyes, Ears, Nose, Throat, or \"Not performed\" if not provided]",
              "Neck": "[Describe findings, or \"Not performed\" if not provided]",
              "Cardiovascular": "[Describe findings, or \"Not performed\" if not provided]",
              "Respiratory": "[Describe findings, or \"Not performed\" if not provided]",
              "Abdomen": "[Describe findings, or \"Not performed\" if not provided]",
              "Musculoskeletal": "[Describe findings, or \"Not performed\" if not provided]",
              "Neurological": "[Describe findings, or \"Not performed\" if not provided]",
              "Skin": "[Describe findings, or \"Not performed\" if not provided]"
            }
          },
          "Assessment": {
            "Diagnosis Deferred": "[Reason for deferring diagnosis, or \"Not mentioned\"]",
            "Differential Diagnosis": "[List of potential diagnoses, or \"Not mentioned\"]",
            "Clinical Impression": "[Summary of the patient's condition, or \"Not mentioned\"]"
          },
          "Plan": {
            "Treatment Plan": "[Suggested Treatment Plan based on the conversation, or \"Not mentioned\"]",
            "Patient Education": "[Topics covered during patient education, or \"Not mentioned\" if not provided in given conversion]",
       “Referral”: “[ name, specialty, hospital and additional information. Include all details of Referrals of this patient to any other doctor if there are any, or “No referrals”]”,
      Ex:{
             “Name”:”doctor name or Not Mentioned”,
             “Speciality”:”Mentioned Speciality or Not Mentioned”,
             “Hospital” :”Mentioned hospital or Not Mentioned”,
           },
             
            "Follow-Up":[
      {
      “TItle” : “Suggest related title”,
      “Description”: “ Recommended follow-up actions, including tests and future appointments, or \"Not mentioned\" if not provided in given conversion”,
      “Duration“: “Give value in days”,
      }
      ],
          },
          "Additional Information": {
            "Medications": "[List of current medications, dosages, and frequency, or \"Not mentioned\" if not provided]",
            "Allergies": "[List of known allergies, or \"Not mentioned\" if not provided]",
                 }
          }
        }
      }
      `,
    },
    {
      id: -2,
      templateName: "Care Plan with Explanation",
      templateTitle: "Care Plan",
      label: "Care Plan with Explanation",
      value:
        "Design a care plan and explain the reasoning behind it using the information from the provided transcript.",
      noteInstructions:
        "Design a care plan and explain the reasoning behind it using the information from the provided transcript.",
    },
    {
      id: -3,
      templateName: "Feedback on Doctor's Performance",
      templateTitle: "Feedback on Doctor",
      label: "Feedback on Doctor's Performance",
      value: `You are an experienced healthcare professional dedicated to providing exceptional patient care. I value your insights, so please analyse the following conversation transcript I had with a patient. I'm interested in a thorough assessment of the following key areas: 1. Communication: 1.1 Clear Language: Did I use clear language and avoid medical jargon? 1.2 Rapport: Did I effectively establish rapport? 1.3 Open Communication: Did I encourage open communication and demonstrate active listening to fully understand the patient's concerns? 2 .History Taking: 2.1 Comprehensive: Was my medical history gathering process comprehensive? 2.2 Probing Questions: Did I ask probing, open-ended questions to obtain the most relevant information? 2.3 Non-Verbal Cues: Did I pay attention to both verbal and non-verbal cues? 3. Patient Education: 3.1Understanding:  Did my explanations regarding their condition and treatment options promote understanding? 3.2Health Literacy: Did I adjust my communication to match the patient's level of health literacy? 4. Shared Decision-Making: 4.1 Patient Involvement: Was the patient involved throughout the decision-making process? 4.2 Respect for Choices:? Did I present options clearly, explore their preferences and values, and respect their choices? 5. Specific Areas of Interest for Feedback: 5.1 Rapport: How effectively did I build trust and create a comfortable environment for the patient? 5.2 Questions: Did I ask clear questions to guide a productive conversation, allowing the patient to express themselves fully? 5.3 Active Listening: Did I demonstrate empathy and understanding by acknowledging their emotions and experiences? 5.4 Explanation: Were my explanations of the patient's condition and treatment plan presented in understandable terms? 5.5 Opportunities: Are there areas where I could have offered additional resources or information to enhance the patient's understanding and empowerment? 5.6 Bedside Manner: Are there any improvements I could make to further the patient's comfort and sense of trust? 5.7 Overall Care: What specific steps can I take to ensure I provide this patient with the best possible care moving forward? Conclusion: Please provide an overall summary of my performance, highlighting both strengths and areas for further development.`,
      noteInstructions:
        "You are an experienced healthcare professional dedicated to providing exceptional patient care. I value your insights, so please analyse the following conversation transcript I had with a patient. I'm interested in a thorough assessment of the following key areas: 1. Communication: 1.1 Clear Language: Did I use clear language and avoid medical jargon? 1.2 Rapport: Did I effectively establish rapport? 1.3 Open Communication: Did I encourage open communication and demonstrate active listening to fully understand the patient's concerns? 2 .History Taking: 2.1 Comprehensive: Was my medical history gathering process comprehensive? 2.2 Probing Questions: Did I ask probing, open-ended questions to obtain the most relevant information? 2.3 Non-Verbal Cues: Did I pay attention to both verbal and non-verbal cues? 3. Patient Education: 3.1Understanding:  Did my explanations regarding their condition and treatment options promote understanding? 3.2Health Literacy: Did I adjust my communication to match the patient's level of health literacy? 4. Shared Decision-Making: 4.1 Patient Involvement: Was the patient involved throughout the decision-making process? 4.2 Respect for Choices:? Did I present options clearly, explore their preferences and values, and respect their choices? 5. Specific Areas of Interest for Feedback: 5.1 Rapport: How effectively did I build trust and create a comfortable environment for the patient? 5.2 Questions: Did I ask clear questions to guide a productive conversation, allowing the patient to express themselves fully? 5.3 Active Listening: Did I demonstrate empathy and understanding by acknowledging their emotions and experiences? 5.4 Explanation: Were my explanations of the patient's condition and treatment plan presented in understandable terms? 5.5 Opportunities: Are there areas where I could have offered additional resources or information to enhance the patient's understanding and empowerment? 5.6 Bedside Manner: Are there any improvements I could make to further the patient's comfort and sense of trust? 5.7 Overall Care: What specific steps can I take to ensure I provide this patient with the best possible care moving forward? Conclusion: Please provide an overall summary of my performance, highlighting both strengths and areas for further development.",
    },
    {
      id: -4,
      templateName: "Referral Letter",
      templateTitle: "Referral Letter",
      label: "Referral Letter",
      value: `Being a healthcare expert, your goal is to analyze the transcript provided to generate a medical referral letter. If there is no medical referral, give the output as “No Medical Referral Provided in the Transcript.” 1.Patient Information: -Name: [Patient's Full Name] -Age: [Patient's Age] -Gender: [Patient's Gender] -Date of Birth: [Patient's Date of Birth] -Medical Record Number: [Patient's Medical Record Number] 2.Chief Complaint: In the patient's own words, provide a comprehensive description of the main reason for the visit, including details on duration, severity, associated symptoms, and impact on daily life. 3.Current Doctor Information: -Referring Doctor: Dr. [Current Doctor's Full Name] -Title/Position: [Current Doctor's Title/Position] -Contact: [Current Doctor's Contact Number] -Email: [Current Doctor's Email Address] -Clinic/Hospital: [Current Clinic/Hospital Name] -Address: [Current Clinic/Hospital Address] 4.Referred Doctor Information: -Referred Doctor: Dr. [Referred Doctor's Full Name] -Title/Position: [Referred Doctor's Title/Position] -Specialization: [Referred Doctor's Specialization] -Contact: [Referred Doctor's Contact Number] -Email: [Referred Doctor's Email Address] -Clinic/Hospital: [Referred Clinic/Hospital Name] -Address: [Referred Clinic/Hospital Address] 5.Reason for Referral: Summarize essential details from the conversation regarding the patient's condition and the necessity for referral. 6.Additional Notes: Include any pertinent information shared by the doctor or patient during the conversation that could impact the referral. 7.[Optional] Family Medical History: Briefly outline any relevant family medical history disclosed during the conversation. 8.[Optional] Medications: Note any current medications the patient is taking, if mentioned. 9.[Optional] Allergies: Document any allergies reported by the patient. 10.[Optional] Previous Treatments: If discussed, provide information on any previous treatments attempted by the patient. Note: Fields marked as [Optional] should be included if the information is provided during the conversation. Omit any fields with missing values.`,
      noteInstructions:
        "Being a healthcare expert, your goal is to analyze the transcript provided to generate a medical referral letter. If there is no medical referral, give the output as “No Medical Referral Provided in the Transcript.” 1.Patient Information: -Name: [Patient's Full Name] -Age: [Patient's Age] -Gender: [Patient's Gender] -Date of Birth: [Patient's Date of Birth] -Medical Record Number: [Patient's Medical Record Number] 2.Chief Complaint: In the patient's own words, provide a comprehensive description of the main reason for the visit, including details on duration, severity, associated symptoms, and impact on daily life. 3.Current Doctor Information: -Referring Doctor: Dr. [Current Doctor's Full Name] -Title/Position: [Current Doctor's Title/Position] -Contact: [Current Doctor's Contact Number] -Email: [Current Doctor's Email Address] -Clinic/Hospital: [Current Clinic/Hospital Name] -Address: [Current Clinic/Hospital Address] 4.Referred Doctor Information: -Referred Doctor: Dr. [Referred Doctor's Full Name] -Title/Position: [Referred Doctor's Title/Position] -Specialization: [Referred Doctor's Specialization] -Contact: [Referred Doctor's Contact Number] -Email: [Referred Doctor's Email Address] -Clinic/Hospital: [Referred Clinic/Hospital Name] -Address: [Referred Clinic/Hospital Address] 5.Reason for Referral: Summarize essential details from the conversation regarding the patient's condition and the necessity for referral. 6.Additional Notes: Include any pertinent information shared by the doctor or patient during the conversation that could impact the referral. 7.[Optional] Family Medical History: Briefly outline any relevant family medical history disclosed during the conversation. 8.[Optional] Medications: Note any current medications the patient is taking, if mentioned. 9.[Optional] Allergies: Document any allergies reported by the patient. 10.[Optional] Previous Treatments: If discussed, provide information on any previous treatments attempted by the patient. Note: Fields marked as [Optional] should be included if the information is provided during the conversation. Omit any fields with missing values.",
    },
    {
      id: -5,
      templateName: "Soap Note General",
      templateTitle: "Soap Note",
      label: "Soap Note General",
      value:
        "Generate SOAP note, include subjective, objective, assessment, plan, and suggestions for ICD-10, CPT codes from the provided transcript. The transcript is as follows:",
      noteInstructions:
        "Generate SOAP note, include subjective, objective, assessment, plan, and suggestions for ICD-10, CPT codes from the provided transcript. The transcript is as follows:",
    },
    {
      id: -6,
      templateName: "Soap Note for Follow-up Visit",
      templateTitle: "Soap Note Follow-up",
      label: "Soap Note for Follow-up Visit",
      value: `A patient returns for a follow-up visit to the doctor's office. As a healthcare professional, your task is to analyse the conversation between the doctor and the patient to create a SOAP note, ensuring comprehensive documentation for continuity of care by capturing all relevant details explicitly mentioned in the given conversation.

      Strict note: Only utilise the data explicitly mentioned in the conversation,do not generate additional information beyond what is provided. Do not assume or hallucinate anything other than what is mentioned in the conversation provided.
      
      Points to consider while generating a SOAP Note:
      
      Only include details explicitly mentioned in the conversation, avoiding assumptions or hallucinations.
      Omit any data not provided during the patient-doctor interaction.
      Maintain clear structure, formatting, and readability.
      Remove unnecessary characters, such as asterisks (*).
      After generating the output, review and format it for grammar, style, and clarity.
      
      Patient Information
      Note: Exclude any placeholders or fields for age or gender unless explicitly stated in the conversation. If mentioned, populate only that field. Also, do not include any patient or doctor names, even if present in the conversation.
      
      Age: [Age as mentioned during the first visit or "Not Available"]
      Gender: [Gender as mentioned during the first visit or "Not Available"]
      Past Medical History: [Summary of past medical conditions, surgeries, hospitalizations, allergies, and medications from the first visit or "Not Available"]
      Family History: [Summary of family medical history from the first visit or "Not Available"]
      Social History: [Summary of lifestyle habits and occupation from the first visit or "Not Available"]
      Review of Systems: [Summary of symptoms related to various body systems from the first visit or "Not Available"]
      
      SOAP Note:
      Subjective:
      
      Chief Complaint (CC): [Main reason for the current visit, as stated by the patient or "Not Available"]
      History of Present Illness (HPI): [Describe the patient's current symptoms, as mentioned in the conversation. Include onset, duration, location, characteristics, severity, and any associated symptoms reported by the patient. If no additional information is provided, leave this section blank or indicate "No additional details provided."]
      Review of Systems (ROS): [Any new or worsening symptoms related to various body systems since the last visit or "Not Available"]
      
      Objective:
      
      Vital Signs: [Recorded vital signs for the current visit, if available or "Not Available"]
      Physical Examination: [Brief findings from the physical examination, focusing on pertinent changes since the last visit or "Not Performed"]
      
      Assessment:
      
      Diagnosis: [Current assessment or diagnosis based on the information gathered or "Not Available"]
      Differential Diagnosis: [Any additional potential diagnoses considered or "Not Available"]
      Clinical Impression: [Provide a summary of the patient's current condition and any changes observed since the last visit, only if explicitly mentioned in the conversation or "Not Available"]
      
      Plan:
      
      Treatment Plan: [Any new treatments initiated or adjustments made to existing treatments or "Not Available"]
      Follow-Up: [Any recommended follow-up actions, such as tests, referrals, or future appointments or "Not Available"]
      Patient Education: [Any relevant educational information provided to the patient or "Not Available"]
      
      Additional Information:
      
      Medications: [List all current medications, dosages, frequency or "Not Available"]
      Allergies: [List known allergies or "Not Available"]
      Financial Status: [Describe a patient's financial situation, including insurance coverage and ability to afford healthcare services or "Not Available"]
      ICD-10 Suggestions: [Based on the assessment and differential diagnoses, consider including relevant ICD-10 codes or "Not Available"]
      CPT Code Suggestions: [Recommend appropriate CPT codes based on the services provided during the encounter or "Not Available"]
      HCC Code(s): [List the HCC codes relevant to the patient's medical conditions or "Not Available"]
      Analytics Table: Mandatory:[Include one relevant analytics table generated from the provided transcript, ensuring it is included only once].
      
      Note: Capture all important information mentioned in the conversation. If any data is missing, simply skip it without adding placeholders such as [missing data] or [Location of pain].`,
      noteInstructions: `A patient returns for a follow-up visit to the doctor's office. As a healthcare professional, your task is to analyse the conversation between the doctor and the patient to create a SOAP note, ensuring comprehensive documentation for continuity of care by capturing all relevant details explicitly mentioned in the given conversation.

      Strict note: Only utilise the data explicitly mentioned in the conversation,do not generate additional information beyond what is provided. Do not assume or hallucinate anything other than what is mentioned in the conversation provided.
      
      Points to consider while generating a SOAP Note:
      
      Only include details explicitly mentioned in the conversation, avoiding assumptions or hallucinations.
      Omit any data not provided during the patient-doctor interaction.
      Maintain clear structure, formatting, and readability.
      Remove unnecessary characters, such as asterisks (*).
      After generating the output, review and format it for grammar, style, and clarity.
      
      Patient Information
      Note: Exclude any placeholders or fields for age or gender unless explicitly stated in the conversation. If mentioned, populate only that field. Also, do not include any patient or doctor names, even if present in the conversation.
      
      Age: [Age as mentioned during the first visit or "Not Available"]
      Gender: [Gender as mentioned during the first visit or "Not Available"]
      Past Medical History: [Summary of past medical conditions, surgeries, hospitalizations, allergies, and medications from the first visit or "Not Available"]
      Family History: [Summary of family medical history from the first visit or "Not Available"]
      Social History: [Summary of lifestyle habits and occupation from the first visit or "Not Available"]
      Review of Systems: [Summary of symptoms related to various body systems from the first visit or "Not Available"]
      
      SOAP Note:
      Subjective:
      
      Chief Complaint (CC): [Main reason for the current visit, as stated by the patient or "Not Available"]
      History of Present Illness (HPI): [Describe the patient's current symptoms, as mentioned in the conversation. Include onset, duration, location, characteristics, severity, and any associated symptoms reported by the patient. If no additional information is provided, leave this section blank or indicate "No additional details provided."]
      Review of Systems (ROS): [Any new or worsening symptoms related to various body systems since the last visit or "Not Available"]
      
      Objective:
      
      Vital Signs: [Recorded vital signs for the current visit, if available or "Not Available"]
      Physical Examination: [Brief findings from the physical examination, focusing on pertinent changes since the last visit or "Not Performed"]
      
      Assessment:
      
      Diagnosis: [Current assessment or diagnosis based on the information gathered or "Not Available"]
      Differential Diagnosis: [Any additional potential diagnoses considered or "Not Available"]
      Clinical Impression: [Provide a summary of the patient's current condition and any changes observed since the last visit, only if explicitly mentioned in the conversation or "Not Available"]
      
      Plan:
      
      Treatment Plan: [Any new treatments initiated or adjustments made to existing treatments or "Not Available"]
      Follow-Up: [Any recommended follow-up actions, such as tests, referrals, or future appointments or "Not Available"]
      Patient Education: [Any relevant educational information provided to the patient or "Not Available"]
      
      Additional Information:
      
      Medications: [List all current medications, dosages, frequency or "Not Available"]
      Allergies: [List known allergies or "Not Available"]
      Financial Status: [Describe a patient's financial situation, including insurance coverage and ability to afford healthcare services or "Not Available"]
      ICD-10 Suggestions: [Based on the assessment and differential diagnoses, consider including relevant ICD-10 codes or "Not Available"]
      CPT Code Suggestions: [Recommend appropriate CPT codes based on the services provided during the encounter or "Not Available"]
      HCC Code(s): [List the HCC codes relevant to the patient's medical conditions or "Not Available"]
      Analytics Table: Mandatory:[Include one relevant analytics table generated from the provided transcript, ensuring it is included only once].
      
      Note: Capture all important information mentioned in the conversation. If any data is missing, simply skip it without adding placeholders such as [missing data] or [Location of pain].`,
    },
  ];
  return defaultTemplates;
};

export const getTranscriptCleanUpPrompts = (
  currentTranscript,
  { language = "English" } = {}
) => {
  return `${getPromtLanguagePrefix(
    language
  )} You are an AI Medical Conversation Transcript Analyst tasked with cleaning up clinical conversations or dictations to ensure accurate documentation of the patient's concerns and the doctor's guidance. Do not generate any if no transcript is provided.

  Tasks:
  
  Identify Dictation: Analyze the transcript to determine if it's dictation or a conversation.
  Identify Speakers: If it's a conversation, carefully analyze and label each speaker as "DOCTOR" or "PATIENT" based on contextual clues such as greetings, questions, and expressions of medical concern.
  Correct Errors: Fix any grammatical errors, misspellings, and punctuation mistakes.
  Enhance Readability: Improve the flow and clarity of the conversation by breaking up long sentences, rearranging phrases, and making minor adjustments.
  Key Points:
  
  Accuracy: Ensure the transcript accurately reflects the original conversation without altering the medical meaning or intent.
  Authenticity: Prioritize clarity while retaining the natural flow of a medical interaction. Avoid making the conversation overly formal or polished.
  Output Format: Provide the cleaned-up transcript in a JSON list format. 
  Example:
  
  json
  Copy code
  [
    {"speakerLabel": "DOCTOR", "text": "Transcript here"},
    {"speakerLabel": "PATIENT", "text": "Transcript here"}
  ]
  Only generate the expected output based solely on the provided conversation without hallucinating additional information.
  Conversation : ${currentTranscript}`;
};

export const getSoapNoteRegenerationPrompt = (
  template,
  currentTranscript,
  { language = "English" } = {}
) => {
  return `${getPromtLanguagePrefix(
    language
  )}  Generate a SOAP Note by incorporating details from both the SOAP note template and a doctor-patient conversation.

  Instructions:
  You will be provided with a SOAP note template in JSON structure representing the patient's initial visit and a doctor-patient conversation representing a follow-up visit.
  Ensure to capture the chief complaints from the SOAP note template and include them in the past medical history section by marking it as patient past medical history.
  
  Input Structure:
  
  SOAP Note Template: JSON format representing the patient's initial visit data.
  Conversation: Representing the follow-up visit data.
  SOAP Note Generation:
  
  Utilize both the SOAP note template and the conversation to extract relevant information about the patient's condition, symptoms, medical history, vital signs, physical examination findings, diagnosis, treatment plan, and referrals.
  Ensure clarity, coherence, and accuracy in the generated SOAP note output.
  SOAP Note Details:
  
  Subjective:
  
  Chief Complaints: [Capture from conversation.]
  History of Present Illness (HPI): [Capture from conversation.]
  Past Medical History (PMH): [Utilize chief complaints and  past medical history  from the SOAP note template.]
  Social History: [Capture from both sources. If not available in either, mention as "Not Recorded".]
  Family History: [Capture from both sources. If not available in either, mention as "Not Recorded".]
  Review of Systems (ROS): [Capture from conversation.]
  Objective:
  
  Vital Signs:
  Old Vitals: [Capture if available from the SOAP note template. If not available, mention as "Not Recorded".]
  New Vitals: [Capture if available from the conversation. If not available, mention as "Not Recorded".]
  General Appearance: [Capture from conversation.]
  Physical Examination: [Capture from conversation.]
  Assessment:
  
  Diagnosis Deferred: [Capture based on both inputs. If not available, mention as "Not Recorded".]
  Differential Diagnosis: [Capture from the conversation. If not available, mention as "Not Recorded".]
  Clinical Impression: [Capture from the conversation. If not available, mention as "Not Recorded".]
  Plan:
  Treatment Plan: [Capture from the conversation. If not available, mention as "Not Recorded".]
  Patient Education: [Capture from the conversation. If not available, mention as "Not Recorded".]
  Immunizations:  [Capture list of immunization. If not available, mention as "Not Recorded".]
  
  Follow-Up: [Capture from the conversation. If not available, mention as "Not Recorded".]
  Referral: [Capture from the conversation. If not available, mention as "Not Recorded".]
  Output Format:
  
  Exclude any placeholders or fields for age or gender unless explicitly stated in the conversation. Do not include any patient or doctor names, even if present.
  Note: Generate the output in the JSON structure only. Use the below format as a sample Example.
  
  {
  "SOAP Note": { // Main section for SOAP Note
  "Patient Information": { // Patient details
  "Age": "...",
  "Gender": "...",
  },
  "Subjective": { // Subjective information
  "Chief Complaint (CC)": "...",
  "History of Present Illness (HPI)": "...",
  “Past Medical History” : “...”,
  "Review of Systems (ROS)": "..."
  },
  "Objective": { // Objective findings
  "Vital Signs": "...",
  "General Appearance": “...”,
  "Physical Examination": "..."
  },
  "Assessment": { // Assessment and diagnosis
  "Diagnosis": "...",
  "Differential Diagnosis": "...",
  "Clinical Impression": "..."
  },
  "Plan": { // Treatment plan
  "Treatment Plan": "...",
   “Immunizations” : ”...”,
  "Follow-Up":[
  {
  “TItle” : “Suggest related title”,
  “Description”: “...”,
  “Duration“: “Give value in days”,
  }
  ],
  “Referral”:[
  {
         “Name”: ”...”,
         “Speciality”: ”...”,
         “Hospital” : ”Mentioned hospital or Not Mentioned”,
       },
  ]
   “...”,
  "Patient Education": "..."
  },
  "Additional Information": { // Additional details
  "Medications": "...",
  "Allergies": "...",
  "Financial Status": "...",
  "HCC Code(s)": "..."
  }
  }
  }

  Soap note template: ${template}
  Conversation :  ${currentTranscript}
  `;
};
export const getCarePlanRegenerationPrompt = (
  template,
  currentTranscript,
  { language = "English" } = {}
) => {
  return `${getPromtLanguagePrefix(language)}
  note template: ${template}
  Conversation :  ${currentTranscript}
  `;
};
export const getFeedbackRegenPrompt = (
  template,
  currentTranscript,
  { language = "English" } = {}
) => {
  return `${getPromtLanguagePrefix(language)}
  note template: ${template}
  Conversation :  ${currentTranscript}
  `;
};
export const getReferralRegenPrompt = (
  template,
  currentTranscript,
  { language = "English" } = {}
) => {
  return `${getPromtLanguagePrefix(language)}
  As a healthcare expert, your task is to generate a medical referral based on two inputs: a SOAP note template representing the patient's initial visit and a follow-up conversation between the doctor and patient. Both conversations pertain to the same patient.
  The SOAP note template captures details from the patient's first visit to the doctor, including chief complaint, current doctor information, referred doctor information, reason for referral, additional notes, family medical history, medications, allergies, and previous treatments where this information is used as patient past medical history.
  Your goal is to analyze If the follow-up conversation explicitly mentions a referral to a specialty-specific doctor, incorporate the relevant details into the referral note.
  Additional Points to Consider:
  Analyze both the SOAP note template and the follow-up conversation to identify any mention of a referral to a specialty-specific doctor.
  Ensure that the referral note captures soap note template chief complaint as patient’s past medical history . Current information , referral information are captured from the conversation, including patient information, Chief Complaint, current doctor information, referred doctor information, reason for referral, past medical history, additional notes, family medical history, medications, allergies, and previous treatments.
  SOAP Note input will be passed in JSON structure using this information as patient past medical history .
  If the follow-up conversation does not contain any referral information, output "No Referral in the conversation."
  Maintain clarity, structure, and readability in the generated referral note.
  Omit any fields with missing values and only include details explicitly mentioned in the conversation.
  If necessary, ask for clarification or additional information to generate a comprehensive referral note.
  note template: ${template}
  Conversation :  ${currentTranscript}
  `;
};

export const getSoapNoteGeneralRegenPrompt = (
  template,
  currentTranscript,
  { language = "English" } = {}
) => {
  return `${getPromtLanguagePrefix(language)}
  note template: ${template}
  Conversation :  ${currentTranscript}
  `;
};

export const getSoapNoteFollowUpRegenPrompt = (
  template,
  currentTranscript,
  { language = "English" } = {}
) => {
  return `${getPromtLanguagePrefix(language)}
  note template: ${template}
  Conversation :  ${currentTranscript}
  `;
};

export const getUpdatedSOAPNoteFromInput = (
  currentNote,
  updateInstructions,
  { language = "English" } = {}
) => {
  return `${getPromtLanguagePrefix(language)}
  
  You are an advanced AI SOAP Note Editor tasked  to update the given SOAP Note with the provided new information, ensuring the structure of the SOAP note is preserved and accurately reflects the latest data. Follow the guidelines below for processing the updates.
  Input:
  SOAP Note: The original SOAP note content in JSON format.
  Instructions: One or more instructions to modify the SOAP note, formatted as follows:
  Direct Field Update: "Field Name: New Value" (e.g., "Chief Complaint: Headache")
  Contextual Information: Plain text describing the new information (e.g., "Patient reports feeling dizzy.")
  Clear Field: "Clear Field Name" (e.g., "Clear Respiratory Rate")
  Output: The updated SOAP note in JSON format.
  Warning Message (if applicable): User-friendly error messages describing the issue.
  Update Rules:
  1. Direct Field Updates:
  Locate: Find the specified "Field Name" in the SOAP note.
  Replace: Update the existing value with the provided "New Value."
  2. Contextual Information Integration:
  Identify Relevance: Determine the most relevant section in the SOAP note for the provided information.
  Existing Label: If a suitable label exists within the relevant section, add the information there.
  New Label: If no suitable label exists, create an appropriate label within the relevant section and place the information under it.
  Additional Information: As a last resort, if no relevant section exists, add the information under an "Additional Information" label within the most contextually appropriate section.
  3. Clear Field:
  Locate: Find the specified "Field Name" in the SOAP note.
  Replace: Update the existing value with "Not mentioned."
  4. Section Management:
  No New Sections: Do not create new sections unless explicitly instructed to do so.
  Preserve Structure: Maintain the original template structure of the SOAP note (Subjective, Objective, Assessment, and Plan).
  5. Data Deletion:
  No Deletion: Do not delete or remove fields; only update or clear their values.
  Error Handling: If an instruction attempts to delete a field or section, return the error message: "Cannot delete this Field or Section" along with the unmodified SOAP note.
  6. Error Handling:
  Invalid Instructions: If an instruction is unclear or invalid, return the error message: "Given Instruction is not clear"
  Examples:
  Example with Error:
  Input:
  Instruction: "Delete Vital Signs"
  Output:
  Warning Message: "Cannot delete this Field or Section"
  Example with Error:
  Input:
  Instruction: "hdfdhdfdg"
  Output:
  Warning Message: "Given Instruction is not clear"
  Outputs:
  The updated SOAP note in JSON format.
  Warning Message (if applicable): User-friendly error messages.
  
  SOAP Note: ${JSON.stringify(currentNote)}
  
  Instructions: ${updateInstructions}`;
};

export const getUpdatedReferralLetterFromInput = (
  currentReferralLetter,
  updateInstructions,
  latestSoapNote,
  language = "English"
) => {
  return `${getPromtLanguagePrefix(language)}

  You are an advanced AI Referral Letter Editor tasked with updating the given Referral Letter with the provided new information, ensuring the structure of the Referral Letter is preserved and accurately reflects the latest data. Follow the guidelines below for processing the updates.
Input:
* Referral Letter: The original Referral Letter content in Text format.
* Instructions: One or more instructions to modify the Referral Letter, formatted as follows:
* Direct Field Update: "Field Name: New Value" (e.g., "Patient Details: John Doe, DOB: 2010-05-10, Gender: male")
* Contextual Information: Plain text describing the new information (e.g., "Patient's symptoms have worsened over the past week.")
* Clear Field: "Clear Field Name" (e.g., "Clear Clinical Summary")
Output: The updated Referral Letter in Text format.
Warning Message (if applicable): User-friendly error messages describing the issue.
Please generate the response as plain Text without any formatting, code block markers and do not prefix with Text keyword.

Update Rules:
1. Direct Field Updates:
  * Locate: Find the specified "Field Name" in the Referral Letter.
  * Replace: Update the existing value with the provided "New Value."
2. Contextual Information Integration:
  * Identify Relevance: Determine the most relevant section in the Referral Letter for the provided information.
  * Existing Label: If a suitable label exists within the relevant section, add the information there.
  * New Label: If no suitable label exists, intelligently create an appropriate label within the relevant section and place the information under it.
  * Additional Information: As a last resort, if no relevant section exists, add the information under an "Additional Information" label within the most contextually appropriate section.
3. Clear Field:
  * Locate: Find the specified "Field Name" in the Referral Letter.
  * Replace: Update the existing value with "Not mentioned."
4. Section Management:
  * No New Sections: Do not create new sections unless explicitly instructed to do so.
  * Preserve Structure: Maintain the original template structure of the Referral Letter.
5. Data Deletion:
  * No Deletion: Do not delete or remove fields; only update or clear their values.
  * Error Handling: If an instruction attempts to delete a field or section, return the error message: "Cannot delete this Field or Section" along with the unmodified Referral Letter.
6. Error Handling:
  * Invalid Instructions: If an instruction is unclear or invalid, return the error message: "Given Instruction is not clear"
7. Special Instruction: Do not include the SOAP Note in the output of the updated Referral Letter.
Examples:
Example with Error:
* Input:
Instruction: "Delete Clinical Summary"
* Output:
Warning Message: "Cannot delete this Field or Section"
Example with Error:
* Input:
Instruction: "abcd1234"
* Output:
Warning Message: "Given Instruction is not clear"
Outputs:
* The updated Referral Letter in Text format.
* Warning Message (if applicable): User-friendly error messages.

Referral Letter: ${currentReferralLetter}
SOAP Note: ${latestSoapNote}
Instructions: ${updateInstructions}`;
};

export const getLanguageChangePromptForSoapNote = (latestSoapNote) => {
  return `
  You are a proficient and precise AI translator tasked with converting a  medical SOAP (Subjective, Objective, Assessment, and Plan) note completely (including key and values) example SOAP Note to Nota SOAP from one language to another.
  The input will be provided in JSON format and can be in either Spanish or English. Translate the entire SOAP note, including labels, field names, and values into the other language while maintaining the same JSON structure. Ensure accuracy in reflecting the original content and pay attention to medical terminology to ensure the translation is clinically appropriate and understandable.
  Intelligently identify the language as either Spanish or English. If the input SOAP note is in Spanish, translate it to English. If the input SOAP note is in English, translate it to Spanish. The output should strictly be the JSON SOAP note converted to the other language. 
  Translate all keys and values: Ensure the translation covers every part of the JSON, including top-level keys like "SOAP_note''. Also ensure output without any formatting, code block markers, or prefixed with the "JSON" keyword.
  SOAP Note:${latestSoapNote}
  `;
};
